import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { AccMonthManageComponent } from './forms/accounting/acc-month.manage';
import { AccountManage } from './forms/administrations/account/account.manage';
import { AdmCenterManageComponent } from './forms/administrations/adm-centers/adm-center.manage';
import { AdministrationManageComponent } from './forms/administrations/administrations/administration.manage';
import { ArticleManage } from './forms/administrations/article/article.manage';
import { BudgetManagerManage } from './forms/administrations/budget-manager/budget-manager.manage';
import { BudgetDetailUI } from './forms/administrations/budget/budget.detail.ui';
import { BudgetManage } from './forms/administrations/budget/budget.manage';
import { CityManageComponent } from './forms/administrations/cities/city.manage';
import { CostCenterManageComponent } from './forms/administrations/cost-centers/cost-center.manage';
import { CountyManageComponent } from './forms/administrations/counties/county.manage';
import { CountryManageComponent } from './forms/administrations/countries/country.manage';
import { DepartmentManageComponent } from './forms/administrations/departments/department.manage';
import { DictionaryItemManageComponent } from './forms/administrations/dictionary-item/dictionary-item.manage';
import { DictionaryTypeManageComponent } from './forms/administrations/dictionary-type/dictionary-type.manage';
import { DivisionManageComponent } from './forms/administrations/divisions/division.manage';
import { EmailManagerManage } from './forms/administrations/email-manager/email-manager.manage';
import { EmailTypeManage } from './forms/administrations/email-type/email-type.manage';
import { EmployeeCostCenterManage } from './forms/administrations/employee-cost-centers/employee-cost-center.manage';
import { EmployeeRoomManage } from './forms/administrations/employee-rooms/employee-room.manage';
import { EmployeeDetailUIComponent } from './forms/administrations/employees/employee.detail.ui';
import { EmployeeManageComponent } from './forms/administrations/employees/employee.manage';
import { ExpAccountManage } from './forms/administrations/exp-account/exp-account.manage';
import { LocationManageComponent } from './forms/administrations/locations/location.manage';
import { MaterialManage } from './forms/administrations/materials/material.manage';
import { OfferDetailUI } from './forms/administrations/offer/offer.detail.ui';
import { OfferManage } from './forms/administrations/offer/offer.manage';
import { OrderDetailUI } from './forms/administrations/order/order.detail.ui';
import { OrderManage } from './forms/administrations/order/order.manage';
import { RegionManageComponent } from './forms/administrations/regions/region.manage';
import { RoomManageComponent } from './forms/administrations/rooms/room.manage';
import { SubTypeManage } from './forms/administrations/sub-types/sub-type.manage';
import { TypeManage } from './forms/administrations/types/type.manage';
import { ActivityManage } from './forms/assets/activities/activity.manage';
import { AssetOpRecoManageComponent } from './forms/assets/asset--reco-ops/asset-reco-op-manage';
import { AssetCategoryManageComponent } from './forms/assets/asset-categories/asset-category.manage';
import { AssetClassManageComponent } from './forms/assets/asset-classes/asset-class.manage';
import { AssetComponentManage } from './forms/assets/asset-components/asset-component.manage';
import { AssetNatureManageComponent } from './forms/assets/asset-natures/asset-nature.manage';
import { AssetOpManageComponent } from './forms/assets/asset-ops/asset-op-manage';
import { AssetStateManageComponent } from './forms/assets/asset-states/asset-state.manage';
import { AssetTypeManageComponent } from './forms/assets/asset-types/asset-type.manage';
import { AssetEmployeeDetailUI } from './forms/assets/assets/asset-employee.detail.ui';
import { AssetInventoryEmailManage } from './forms/assets/assets/asset-inventory-email.manage';
import { AssetInventoryEmployeeValidateManage } from './forms/assets/assets/asset-inventory-employee-validate.manage';
import { AssetInventoryReportComponent } from './forms/assets/assets/asset-inventory-report';
import { AssetInventoryManageComponent } from './forms/assets/assets/asset-inventory.manage';
import { AssetDetailUIComponent } from './forms/assets/assets/asset.detail.ui';
import { AssetManageComponent } from './forms/assets/assets/asset.manage';
import { BrandManage } from './forms/assets/brands/brand.manage';
import { CategoryENManageComponent } from './forms/assets/categories-en/category-en.manage';
import { CategoryManageComponent } from './forms/assets/categories/category.manage';
import { CompanyManageComponent } from './forms/assets/companies/company.manage';
import { DimensionManageComponent } from './forms/assets/dimensions/dimension.manage';
import { InsuranceCategoryManage } from './forms/assets/insurance-categories/insurance-category.manage';
import { InterCompanyENManageComponent } from './forms/assets/inter-companies-en/inter-company-en.manage';
import { InterCompanyManageComponent } from './forms/assets/inter-companies/inter-company.manage';
import { ModelManage } from './forms/assets/models/model.manage';
import { ProjectManage } from './forms/assets/projects/project.manage';
import { SubCategoryENManageComponent } from './forms/assets/sub-categories-en/sub-category-en.manage';
import { SubCategoryManageComponent } from './forms/assets/sub-categories/sub-category.manage';
import { UomManageComponent } from './forms/assets/uoms/uom.manage';
import { IdentityManage } from './forms/auth/identity.manage';
import { BadgeManage } from './forms/common/badge/badge.manage';
import { ColumnDefinitionManageComponent } from './forms/common/column-definition/column-definition.manage';
import { ConfigValuesManage } from './forms/common/config-values.manage';
import { DeviceTypeManage } from './forms/common/device-types/device-type.manage';
import { DeviceManage } from './forms/common/devices/device.manage';
import { LocationMap } from './forms/common/maps/maps';
import { PermissionRoleManage } from './forms/common/permission-role/permission-role.manage';
import { PermissionTypeManage } from './forms/common/permission-type/permission-type.manage';
import { PermissionManage } from './forms/common/permission/permission.manage';
import { RouteChildManageComponent } from './forms/common/route-child-definition/route-child.manage';
import { RouteManageComponent } from './forms/common/route-definition/route.manage';
import { TableDefinitionManageComponent } from './forms/common/table-definition/table-definition.manage';
import { OperationDetail } from './forms/documents/operations/operation.detail';
import { PartnerManageComponent } from './forms/documents/partners/partner.manage';
import { InvStateManage } from './forms/inventory/inv-state/inv-state.manage';
import { InventoryManage } from './forms/inventory/inventory.manage';
import { AuthGuard } from './services/auth.guard';
import { DashboardBudgetAssetComponent } from './views/dashboard/Budget/dashboard-budget-asset.component';
import { DashboardBudgetComponent } from './views/dashboard/Budget/dashboard-budget.component';
import { DashboardInventoryMarkComponent } from './views/dashboard/dashboard-inventory-mark.component';
import { DashboardInventoryComponent } from './views/dashboard/dashboard-inventory.component';
import { DashboardOfferComponent } from './views/dashboard/dashboard-offer.component';
import { DashboardOrderComponent } from './views/dashboard/dashboard-order.component';
import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '',
    //redirectTo: '/',
    children: [
          {
            path: 'newassetemployee/:id', component: AssetEmployeeDetailUI, data: { title: 'Validare angajati' } ,
            loadChildren: () => import('./forms/assets/assets/asset-employee.detail.ui').then(m => m.AssetEmployeeDetailUI)
          },
     ],
    pathMatch: 'full',
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: ''
    },
    children: [
      // {
      //   path: 'base',
      //   loadChildren: () => import('./views/base/base.module').then(m => m.BaseModule)
      // },
      // {
      //   path: 'buttons',
      //   loadChildren: () => import('./views/buttons/buttons.module').then(m => m.ButtonsModule)
      // },
      // {
      //   path: 'charts',
      //   loadChildren: () => import('./views/chartjs/chartjs.module').then(m => m.ChartJSModule)
      // },
      // {
      //   path: 'dashboard',
      //   loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      // },
      // {
      //   path: 'map',
      //   loadChildren: () => import('./views/maps/maps.module').then(m => m.MapsModule)
      // },
      // {
      //   path: 'floor',
      //   loadChildren: () => import('./views/floors/floors.module').then(m => m.FloorsModule)
      // },
      // {
      //   path: 'budget',
      //   loadChildren: () => import('./views/budgets/budgets.module').then(m => m.BudgetsModule)
      // },
      // {
      //   path: 'offer',
      //   loadChildren: () => import('./views/offers/offers.module').then(m => m.OffersModule)
      // },
      // {
      //   path: 'order',
      //   loadChildren: () => import('./views/orders/orders.module').then(m => m.OrdersModule)
      // },
      // {
      //   path: 'asset',
      //   loadChildren: () => import('./views/assets/assets.module').then(m => m.AssetsModule)
      // },
      // {
      //   path: 'assetcomponent',
      //   loadChildren: () => import('./views/assetcomponents/assetcomponents.module').then(m => m.AssetComponentsModule)
      // },
      // {
      //   path: 'employee',
      //   loadChildren: () => import('./views/employees/employees.module').then(m => m.EmployeesModule)
      // },
      // {
      //   path: 'wfh',
      //   loadChildren: () => import('./views/wfhs/wfhs.module').then(m => m.WfhsModule)
      // },
      // {
      //   path: 'inventory',
      //   loadChildren: () => import('./views/inventories/inventories.module').then(m => m.InventoriesModule)
      // },
      // {
      //   path: 'email',
      //   loadChildren: () => import('./views/emails/emails.module').then(m => m.EmailsModule)
      // },
      // {
      //   path: 'operation',
      //   loadChildren: () => import('./views/operations/operations.module').then(m => m.OperationsModule)
      // },
      // {
      //   path: 'admin',
      //   loadChildren: () => import('./views/admin/admin.module').then(m => m.AdminModule)
      // },
      // {
      //   path: 'icons',
      //   loadChildren: () => import('./views/icons/icons.module').then(m => m.IconsModule)
      // },
      // {
      //   path: 'notifications',
      //   loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule)
      // },
      // {
      //   path: 'configs',
      //   loadChildren: () => import('./views/configs/configs.module').then(m => m.ConfigsModule)
      // },
      // {
      //   path: 'routes',
      //   loadChildren: () => import('./views/routes/routes.module').then(m => m.RoutesModule)
      // },
      // {
      //   path: 'nomenclatures',
      //   loadChildren: () => import('./views/nomenclatures/nomenclatures.module').then(m => m.NomenclaturesModule)
      // },
      // {
      //   path: 'theme',
      //   loadChildren: () => import('./views/theme/theme.module').then(m => m.ThemeModule)
      // },
      // {
      //   path: 'widgets',
      //   loadChildren: () => import('./views/widgets/widgets.module').then(m => m.WidgetsModule)
      // }
    ]
  },

  // DASHBOARD // 

  { path: 'dashboard/budget', component: DashboardBudgetComponent, canActivate: [AuthGuard], data: { title: '', auth: 'VIEW|S_DASHBOARD_BUDGET', shouldDetach: true }},
  { path: 'dashboard/budgetasset', component: DashboardBudgetAssetComponent, canActivate: [AuthGuard], data: { title: '', auth: 'VIEW|S_DASHBOARD_BUDGET', shouldDetach: true }},
  { path: 'dashboard/offer', component: DashboardOfferComponent, canActivate: [AuthGuard], data: { title: '', auth: 'VIEW|S_DASHBOARD_OFFER', shouldDetach: true }},
  { path: 'dashboard/order', component: DashboardOrderComponent, canActivate: [AuthGuard], data: { title: '', auth: 'VIEW|S_DASHBOARD_ORDER', shouldDetach: true }},
  { path: 'dashboard/inventory', component: DashboardInventoryComponent, canActivate: [AuthGuard], data: { title: '', auth: 'VIEW|S_DASHBOARD_INVENTORY', shouldDetach: true }},
  { path: 'dashboard/inventorymark', component: DashboardInventoryMarkComponent, canActivate: [AuthGuard], data: { title: '', auth: 'VIEW|S_DASHBOARD_INVENTORY_MARK', shouldDetach: true }},

  // DASHBOARDS //

  // MAPS // 

  { path: 'map', component: LocationMap, canActivate: [AuthGuard], data: { title: 'Harti', auth: 'VIEW|MAP', shouldDetach: true }},

  // MAPS //

  // BUDGETS //

  { path: 'budget', component: BudgetManage, canActivate: [AuthGuard], data: { title: '', auth: 'VIEW|BUDGET', shouldDetach: true }},
  { path: 'budget/:id', component: BudgetDetailUI, canActivate: [AuthGuard], data: {  title: '', auth: 'EDIT|BUDGET', shouldDetach: false }},
  { path: 'budget/new', component: BudgetDetailUI, canActivate: [AuthGuard], data: {  title: '', auth: 'ADD|BUDGET', shouldDetach: false }},

  // BUDGETS //

  // OFFERS //

  { path: 'offer/status', canActivate: [AuthGuard], component: OfferManage, data: { title: '', auth: 'VIEW|S_OFFER_STATUS', shouldDetach: true }},
  { path: 'offer/email', canActivate: [AuthGuard], component: EmailManagerManage, data: { title: '', auth: 'VIEW|S_OFFER_EMAIL', shouldDetach: true }},
  { path: 'offer/:id', component: OfferDetailUI, canActivate: [AuthGuard], data: { title: '', auth: 'EDIT|OFFER', shouldDetach: false }},
  { path: 'offer/new', component: OfferDetailUI, canActivate: [AuthGuard], data: { title: '', auth: 'ADD|OFFER', shouldDetach: false }},

  // OFFERS //

  // ORDERS //

  { path: 'order', canActivate: [AuthGuard], component: OrderManage, data: { title: '', auth: 'VIEW|ORDER', shouldDetach: true}},
  { path: 'order/:id', component: OrderDetailUI, canActivate: [AuthGuard], data: { title: '', auth: 'EDIT|ORDER', shouldDetach: false }},
  { path: 'order/new', component: OrderDetailUI, canActivate: [AuthGuard], data: { title: '', auth: 'ADD|ORDER', shouldDetach: false }},

  // ORDERS //

  // ASSET //

  { path: 'asset', component: AssetManageComponent, canActivate: [AuthGuard], data: { title: '', auth: 'VIEW|ASSET', shouldDetach: true}},
  { path: 'asset/newoperation', component: OperationDetail, canActivate: [AuthGuard], data: {  title: '', auth: 'ADD_TRANSFER|ASSET', shouldDetach: false }},
  { path: 'asset/:id', component: AssetDetailUIComponent, canActivate: [AuthGuard], data: { title: '', auth: 'EDIT|ASSET', shouldDetach: false }},
  { path: 'asset/new', component: AssetDetailUIComponent, canActivate: [AuthGuard], data: { title: '', auth: 'ADD|ASSET', shouldDetach: false }},

  // ASSET //

  // ASSETCOMPONENT //

  { path: 'assetcomponent', canActivate: [AuthGuard], component: AssetComponentManage, data: { title: 'Accesorii', auth: 'VIEW|COMPONENT', shouldDetach: true }},
  
  // ASSETCOMPONENT //

  // EMPLOYEE //

  { path: 'employee', canActivate: [AuthGuard], component: EmployeeManageComponent, data: { title: 'Angajati', auth: 'VIEW|EMPLOYEES', shouldDetach: true }},
  { path: 'employee/:id', component: EmployeeDetailUIComponent, canActivate: [AuthGuard], data: { title: '', auth: 'OPERATION|EMPLOYEES', shouldDetach: false }},
  { path: 'employeecostcenters', canActivate: [AuthGuard], component: EmployeeCostCenterManage, data: { title: 'Angajati/ CC', auth: 'VIEW|EMPLOYEECOSTCENTERS', shouldDetach: true }},
  { path: 'employeerooms', canActivate: [AuthGuard], component: EmployeeRoomManage, data: { title: 'Angajati/ Locatii', auth: 'VIEW|EMPLOYEEROOMS', shouldDetach: true }},
     { path: 'wfh/:id' , component: AssetEmployeeDetailUI, data: { title: 'Validare angajati' } },
  // EMPLOYEE //

  // WFH //

  { path: 'wfh/validate', canActivate: [AuthGuard], component: AssetInventoryEmployeeValidateManage, data: { title: 'Validare', auth: 'VIEW|S_WFH_VALIDATE', shouldDetach: true }},
  { path: 'wfh/email', canActivate: [AuthGuard], component: AssetInventoryEmailManage, data: { title: 'Status', auth: 'VIEW|S_WFH_STATUS', shouldDetach: true }},

  // WFH //

  // INVENTORIES //

  { path: 'inventory/status', canActivate: [AuthGuard], component: AssetInventoryManageComponent, data: { title: 'Status', auth: 'VIEW|S_INVENTORY_STATUS', shouldDetach: true }},
  { path: 'inventory/report', canActivate: [AuthGuard], component: AssetInventoryReportComponent, data: { title: 'Rapoarte', auth: 'VIEW|S_INVENTORY_REPORT', shouldDetach: true }},
  { path: 'inventory/reco', canActivate: [AuthGuard], component: AssetOpRecoManageComponent, data: { title: 'Reconcilieri', auth: 'VIEW|OPERATION', shouldDetach: true }},

  // INVENTORIES //

  // EMAILS //

  { path: 'email', canActivate: [AuthGuard], component: EmailTypeManage, data: { title: 'Setari email', auth: 'VIEW|EMAIL_SETTING', shouldDetach: true }},

  // EMAILS //

  // OPRATIONS //

  { path: 'operation', canActivate: [AuthGuard], component: AssetOpManageComponent, data: { title: 'Operatii', auth: 'VIEW|OPERATION', shouldDetach: true }},
  

  // OPERATIONS //

  // ADMIN //

  { path: 'admin', canActivate: [AuthGuard], component: IdentityManage, data: { title: 'Admin', auth: 'VIEW|ADMIN', shouldDetach: true }},

  // ADMIN //

  // CONFIGS //

  { path: 'config/global', component: ConfigValuesManage, data: { title: 'Global'}},
  { path: 'config/table', component: TableDefinitionManageComponent, data: { title: 'Table' }},
  { path: 'config/column', component: ColumnDefinitionManageComponent, data: { title: 'Coloane'}},
  { path: 'config/permissiontype', component: PermissionTypeManage, data: { title: 'Ecran' }},
  { path: 'config/permission', component: PermissionManage, data: { title: 'Permisiuni' }},
  { path: 'config/permissionrole', component: PermissionRoleManage, data: { title: 'Permisiuni/Roluri' }},

  // CONFIGS // 

  // ROUTES //

  { path: 'routes/parent', component: RouteManageComponent, data: { title: 'Parinte', shouldDetach: true}},
  { path: 'routes/children', component: RouteChildManageComponent, data: { title: 'Copil', shouldDetach: true }},
  { path: 'routes/badge', component: BadgeManage, data: { title: 'Badges', shouldDetach: true}},

  // ROUTES //

  // NOMENCLATURES //

  { path: 'nom/accmonths', canActivate: [AuthGuard], component: AccMonthManageComponent, data: { title: 'Inventare', auth: 'VIEW|ACCMONTHS', shouldDetach: true }},
  { path: 'nom/inventories', canActivate: [AuthGuard], component: InventoryManage, data: { title: 'Inventare', auth: 'VIEW|INVENTORIES', shouldDetach: true }},
  { path: 'nom/companies', canActivate: [AuthGuard], component: CompanyManageComponent, data: { title: 'Categorii', auth: 'VIEW|COMPANIES', shouldDetach: true }},
  { path: 'nom/assetnatures', canActivate: [AuthGuard], component: AssetNatureManageComponent, data: { title: 'Culori', auth: 'VIEW|ASSETNATURES', shouldDetach: true }},
  { path: 'nom/invstates', canActivate: [AuthGuard], component: InvStateManage, data: { title: 'Stari', auth: 'VIEW|INVSTATES', shouldDetach: true }},
  { path: 'nom/assetstates', canActivate: [AuthGuard], component: AssetStateManageComponent, data: { title: 'Tipuri operatii', auth: 'VIEW|ASSETSTATES', shouldDetach: true }},
  { path: 'nom/counties', canActivate: [AuthGuard], component: CountyManageComponent, data: { title: 'Judete', auth: 'VIEW|COUNTIES', shouldDetach: true}},
  { path: 'nom/cities', canActivate: [AuthGuard], component: CityManageComponent, data: { title: 'Orase', auth: 'VIEW|CITIES', shouldDetach: true }},
  { path: 'nom/cities', canActivate: [AuthGuard], component: CityManageComponent, data: { title: 'Orase', auth: 'VIEW|CITIES', shouldDetach: true }},
  { path: 'nom/locations', canActivate: [AuthGuard], component: LocationManageComponent, data: { title: 'Adrese', auth: 'VIEW|LOCATIONS', shouldDetach: true}},
  { path: 'nom/rooms', canActivate: [AuthGuard], component: RoomManageComponent, data: { title: 'Adrese 2',auth: 'VIEW|ROOMS', shouldDetach: true}},
  { path: 'nom/accounts', canActivate: [AuthGuard], component: AccountManage, data: { title: 'Bal.sh.acct APC', auth: 'VIEW|ACCOUNTS', shouldDetach: true }},
  { path: 'nom/expaccounts', canActivate: [AuthGuard], component: ExpAccountManage, data: { title: 'Asset class', auth: 'VIEW|EXPACCOUNTS', shouldDetach: true }},  
  { path: 'nom/assetcategories', canActivate: [AuthGuard], component: AssetCategoryManageComponent, data: { title: 'Asset classification', auth: 'VIEW|ASSETCATEGORIES', shouldDetach: true }},
  { path: 'nom/partners', canActivate: [AuthGuard], component: PartnerManageComponent, data: { title: 'Suppliers', auth: 'VIEW|PARTNERS', shouldDetach: true }},
  { path: 'nom/articles', canActivate: [AuthGuard], component: ArticleManage, data: { title: 'Zone', auth: 'VIEW|ARTICLES', shouldDetach: true }},
  { path: 'nom/costcenters', canActivate: [AuthGuard], component: CostCenterManageComponent, data: { title: 'Centre de cost', auth: 'VIEW|COSTCENTERS', shouldDetach: true }},
  { path: 'nom/admcenters', canActivate: [AuthGuard], component: AdmCenterManageComponent, data: { title: 'Profit centers', auth: 'VIEW|ADMCENTERS', shouldDetach: true }},
  { path: 'nom/regions', canActivate: [AuthGuard], component: RegionManageComponent, data: { title: 'PC detaliu', auth: 'VIEW|REGIONS', shouldDetach: true }},
  { path: 'nom/departments', canActivate: [AuthGuard], component: DepartmentManageComponent, data: { title: 'Departamente', auth: 'VIEW|DEPARTMENTS', shouldDetach: true }},
  { path: 'nom/divisions', canActivate: [AuthGuard], component: DivisionManageComponent, data: { title: 'Divizii', auth: 'VIEW|DIVISIONS', shouldDetach: true }},
  { path: 'nom/administrations', canActivate: [AuthGuard], component: AdministrationManageComponent, data: { title: 'Locatii', auth: 'VIEW|ADMINISTRATIONS', shouldDetach: true}},
  { path: 'nom/countries', canActivate: [AuthGuard], component: CountryManageComponent, data: { title: 'Tari', auth: 'VIEW|COUNTRIES', shouldDetach: true }},
  { path: 'nom/budgetmanagers', canActivate: [AuthGuard], component: BudgetManagerManage, data: { title: 'FY Start', auth: 'VIEW|BUDGETMANAGERS', shouldDetach: true}},
  { path: 'nom/assetnatures', canActivate: [AuthGuard], component: AssetNatureManageComponent, data: { title: 'Cont CM', auth: 'VIEW|ASSETNATURES', shouldDetach: true }},
  // { path: 'nom/mastertypes', canActivate: [AuthGuard], component: MasterTypeManageComponent, data: { title: 'PC', auth: 'VIEW|MASTERTYPES', shouldDetach: true }},
  { path: 'nom/types', canActivate: [AuthGuard], component: TypeManage, data: { title: 'Supracategorii', auth: 'VIEW|TYPES', shouldDetach: true }},
  { path: 'nom/materials', canActivate: [AuthGuard], component: MaterialManage, data: { title: 'Materiale', auth: 'VIEW|MATERIALS', shouldDetach: true }},
  { path: 'nom/subtypes', canActivate: [AuthGuard], component: SubTypeManage, data: { title: 'Tipuri active', auth: 'VIEW|SUBTYPES', shouldDetach: true }},
  { path: 'nom/assetclasses', canActivate: [AuthGuard], component: AssetClassManageComponent, data: { title: 'Clasificari', auth: 'VIEW|ASSETCLASSES', shouldDetach: true}},
  { path: 'nom/dictionarytypes', canActivate: [AuthGuard], component: DictionaryTypeManageComponent, data: { title: 'Tip dictionar', auth: 'VIEW|DICTIONARYTYPES', shouldDetach: true}},
  { path: 'nom/dictionaryitems', canActivate: [AuthGuard], component: DictionaryItemManageComponent, data: { title: 'Dictionar', auth: 'VIEW|DICTIONARYITEMS', shouldDetach: true }},
  { path: 'nom/intercompanies', canActivate: [AuthGuard], component: InterCompanyManageComponent, data: { title: 'Supracategorii TRN', auth: 'VIEW|INTERCOMPANIES', shouldDetach: true }},
  { path: 'nom/intercompaniesen', canActivate: [AuthGuard], component: InterCompanyENManageComponent, data: { title: 'Supracategorii EN', auth: 'VIEW|INTERCOMPANIESEN', shouldDetach: true }},
  { path: 'nom/categories', canActivate: [AuthGuard], component: CategoryManageComponent, data: { title: 'Categorii', auth: 'VIEW|CATEGORIES', shouldDetach: true }},
  { path: 'nom/subcategories', canActivate: [AuthGuard], component: SubCategoryManageComponent, data: { title: 'SubCategorii', auth: 'VIEW|SUBCATEGORIES', shouldDetach: true }},
  { path: 'nom/categoriesen', canActivate: [AuthGuard], component: CategoryENManageComponent, data: { title: 'Categorii EN', auth: 'VIEW|CATEGORIESEN', shouldDetach: true }},
  { path: 'nom/subcategoriesen', canActivate: [AuthGuard], component: SubCategoryENManageComponent, data: { title: 'SubCategorii EN', auth: 'VIEW|SUBCATEGORIESEN', shouldDetach: true }},
  { path: 'nom/uoms', canActivate: [AuthGuard], component: UomManageComponent, data: { title: 'Simboluri', auth: 'VIEW|UOMS', shouldDetach: true }},
  { path: 'nom/dimensions', canActivate: [AuthGuard], component: DimensionManageComponent, data: { title: 'Dimensiuni', auth: 'VIEW|DIMENSIONS', shouldDetach: true}},
  { path: 'nom/insurancecategories', canActivate: [AuthGuard], component: InsuranceCategoryManage, data: { title: 'BS', auth: 'VIEW|INSURANCECATEGORIES', shouldDetach: true }},
  { path: 'nom/assettypes', canActivate: [AuthGuard], component: AssetTypeManageComponent, data: { title: 'Tipuri', auth: 'VIEW|ASSETTYPES', shouldDetach: true }},
  { path: 'nom/projects', canActivate: [AuthGuard], component: ProjectManage, data: { title: 'WBS', auth: 'VIEW|PROJECTS', shouldDetach: true }},
  { path: 'nom/activities', canActivate: [AuthGuard], component: ActivityManage, data: { title: 'WBS', auth: 'VIEW|ACTIVITIES', shouldDetach: true }},
  { path: 'nom/brands', canActivate: [AuthGuard], component: BrandManage, data: { title: 'Branduri', auth: 'VIEW|BRANDS', shouldDetach: true }},
  { path: 'nom/models', canActivate: [AuthGuard], component: ModelManage, data: { title: 'Modele', auth: 'VIEW|MODELS', shouldDetach: true }},
  { path: 'nom/devicetypes', canActivate: [AuthGuard], component: DeviceTypeManage, data: { title: 'OS', auth: 'VIEW|DEVICETYPES', shouldDetach: true }},
  { path: 'nom/devices', canActivate: [AuthGuard], component: DeviceManage, data: { title: 'OS', auth: 'VIEW|DEVICES', shouldDetach: true }},

  // NOMENCLATURES //


  { path: '**', component: P404Component },

];

@NgModule({
  imports: [ RouterModule.forRoot(AppRoutes, { relativeLinkResolution: 'legacy' }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
